/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
export var SummaryOperand = /*@__PURE__*/ (function (SummaryOperand) {
    SummaryOperand[SummaryOperand["Min"] = 0] = "Min";
    SummaryOperand[SummaryOperand["Max"] = 1] = "Max";
    SummaryOperand[SummaryOperand["Sum"] = 2] = "Sum";
    SummaryOperand[SummaryOperand["Average"] = 3] = "Average";
    SummaryOperand[SummaryOperand["Count"] = 4] = "Count";
    SummaryOperand[SummaryOperand["Custom"] = 5] = "Custom";
    return SummaryOperand;
})({});
/**
 * @hidden
 */
export var SummaryOperand_$type = /*@__PURE__*/ markEnum('SummaryOperand', 'Min,0|Max,1|Sum,2|Average,3|Count,4|Custom,5');
//# sourceMappingURL=SummaryOperand.js.map
